import { useEffect } from "react";
import { setStorageItem } from "../../../utils/local-storage";
import { useLanguageParam } from "../utils";

interface IProps {
	event: number | undefined;
}

const useRedirectLanguage = ({ event }: IProps): void => {
	const language = useLanguageParam();

	// Keep localStorage in sync with the URL language param.
	// The URL is the source of truth — localStorage is just a cache of the user's last-used language
	// so that other code (e.g., Redirects utility) can reference it when generating URLs.
	useEffect(() => {
		if (event && language) {
			setStorageItem(`event.${event}.language`, language);
		}
	}, [language, event]);
};

export default useRedirectLanguage;
